import { User } from '../../model/types';

export const getUserName = (userData: Nullable<User>): string => {
  if (!userData) {
    return '';
  }

  return userData.company ? userData.company : `${userData.firstName} ${userData.lastName}`;
};
